module.exports = "/logo-vertical-0d25ba1539feb2796d0a78774f5be3db.svg";